import {
  FETCH_PROMOTIONS_DATA,
  FETCH_PROMOTIONS_SUCCESS,
  FETCH_PROMOTIONS_FAILURE,
  FETCH_PROMOTIONS_EDIT_DATA,
  FETCH_PROMOTIONS_EDIT_SUCCESS,
  FETCH_PROMOTIONS_EDIT_FAILURE,
} from "./actionTypes";

export const fetchPromotionsData = () => ({
  type: FETCH_PROMOTIONS_DATA,
});

export const fetchPromotionsSuccess = (data) => ({
  type: FETCH_PROMOTIONS_SUCCESS,
  payload: data,
});

export const fetchPromotionsFailure = (error) => ({
  type: FETCH_PROMOTIONS_FAILURE,
  payload: error,
});

export const fetchPromotionsEditData = (id) => ({
  type: FETCH_PROMOTIONS_EDIT_DATA,
  payload: id,
});

export const fetchPromotionsEditSuccess = (data) => ({
  type: FETCH_PROMOTIONS_EDIT_SUCCESS,
  payload: data,
});

export const fetchPromotionsEditFailure = (error) => ({
  type: FETCH_PROMOTIONS_EDIT_FAILURE,
  payload: error,
});
